"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FloatComponent.default;
  }
});

var _FloatComponent = _interopRequireDefault(require("./Float-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }